@if (show(); as show) {
  <div class="fixed inset-0 z-50 bg-brand-cream flex flex-col overflow-y-auto">
    <app-popup-close (closed)="close()" />
    <div class="flex flex-col items-center justify-center flex-1 p-8 text-black">
      <article class="w-full max-w-md bg-white border-3 border-black">
        <div class="flex flex-col gap-2 p-4">
          <p class="font-hand text-2xl leading-7 text-heat">{{ when() }}</p>
          <h1 class="font-display font-bold uppercase text-4xl leading-9 tracking-wide">{{ title() }}</h1>
          @if (details()) {
            <p class="font-body">{{ details() }}</p>
          }
          @if (show.url) {
            <a [href]="show.url" target="_blank" rel="noopener noreferrer" class="hh-btn text-lg mt-2 self-start">RSVP</a>
          }
        </div>
      </article>
    </div>
  </div>
}
